import React, { forwardRef, useState } from 'react'
import { Select, Checkbox, Divider } from 'antd'
import { formatMessageNew } from '@/utils/common'
const SelectAll = forwardRef((props, ref) => {
  const { selectAllBack, showAll, allowClearFlag, selectList, formValues, selectKey, initialValues, ...resItem } = props
  let checkedall1 = false
  let initialValuesForm = formValues ? formValues[selectKey] : initialValues

  if (selectList && initialValuesForm && props.mode === 'multiple') {
    let sel = initialValuesForm
    let selLs = []
    for (let index = 0; index < sel.length; index++) {
      const element = sel[index]
      let selRes = selectList.findIndex(item => {
        return item.value === element
      })
      if (selRes !== -1) {
        selLs.push(element)
      }
    }
    if (selectList.length === selLs.length && selLs.length > 0) {
      checkedall1 = true
    } else {
      checkedall1 = false
    }
  }

  const [checkedall, setCheckedall] = useState(checkedall1)
  const [checkedallDis, setCheckedallDis] = useState(false)
  const checkallChange = e => {
    let ls = selectList.map(item => item.value)
    if (!e.target.checked) {
      ls = []
    }
    setCheckedall(e.target.checked)
    selectAllBack && selectAllBack(ls)
  }
  const isSelectAll = e => {
    let ls = selectList.map(item => item.value)
    if (props.mode === 'multiple' && e.length === ls.length) {
      setCheckedall(true)
    } else {
      setCheckedall(false)
    }
  }
  return (
    <>
      <Select
        showSearch
        style={{ width: '100%' }}
        // className='nike_select'
        placeholder={formatMessageNew('languageObj.commonLocale.placeholderSelect')}
        optionFilterProp="children"
        filterOption={(input, option) => {
          return option.props.children && option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }}
        allowClear={allowClearFlag}
        dropdownRender={menu => (
          <div>
            {showAll ? (
              <div>
                <div
                  style={{ padding: '4px 8px' }}
                  onMouseDown={e => {
                    e.preventDefault()
                    e.stopPropagation()
                  }}
                >
                  <Checkbox
                    disabled={checkedallDis}
                    onClick={e => {
                      checkallChange(e, selectList)
                    }}
                    checked={checkedall}
                  >
                    {formatMessageNew('languageObj.commonLocale.all')}
                  </Checkbox>
                </div>
                <Divider style={{ margin: '4px 0' }} />
              </div>
            ) : null}
            {menu}
          </div>
        )}
        {...resItem}
        onChange={e => {
          setCheckedallDis(false)
          isSelectAll(e)
          selectAllBack && selectAllBack(e)
        }}
        onSearch={e => {
          // 搜索时禁用全选
          if (e) {
            setCheckedallDis(true)
          } else {
            setCheckedallDis(false)
          }
        }}
      >
        {selectList.map((itemSel, idxSel) => {
          const labelContent = typeof itemSel.label === 'function' ? itemSel.label() : itemSel.label
          return (
            <Select.Option key={idxSel} value={itemSel.value}>
              {labelContent}
            </Select.Option>
          )
        })}
      </Select>
    </>
  )
})
export default React.memo(SelectAll)
